import { Link } from 'react-router-dom';

const catLinks = [
  { label: '奇幻漫画', to: '/fantasy' },
  { label: '校园漫画', to: '/campus' },
  { label: '恋爱漫画', to: '/romance' },
];

const infoLinks = [
  { label: '关于我们', to: '/about' },
  { label: '常见问题', to: '/faq' },
  { label: '返回首页', to: '/' },
];

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-200">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-lg text-background-50">
                <i className="ri-book-open-line" />
              </span>
              <span className="font-heading text-xl text-background-50">韩漫漫画网</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">
              韩漫漫画网聚合奇幻、校园、恋爱等热门题材韩漫，分类清晰直达，点开即看。不用反复搜索，一站找齐你想看的韩漫类型，快速定位心头好。
            </p>
            <div className="mt-5 flex items-center gap-3 text-background-300">
              <a
                href="https://lovecomix.github.io"
                aria-label="官方微博"
                rel="nofollow noopener"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 hover:text-background-50"
              >
                <i className="ri-weibo-line" />
              </a>
              <a
                href="https://lovecomix.github.io"
                aria-label="哔哩哔哩"
                rel="nofollow noopener"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 hover:text-background-50"
              >
                <i className="ri-bilibili-line" />
              </a>
              <a
                href="https://lovecomix.github.io"
                aria-label="微信公众号"
                rel="nofollow noopener"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 hover:text-background-50"
              >
                <i className="ri-wechat-line" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="mb-4 text-sm font-semibold text-background-50">题材分类</h4>
            <ul className="space-y-2.5 text-sm">
              {catLinks.map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="text-background-300 transition-colors hover:text-background-50">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 text-sm font-semibold text-background-50">站点导航</h4>
            <ul className="space-y-2.5 text-sm">
              {infoLinks.map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="text-background-300 transition-colors hover:text-background-50">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-50/10 pt-6 text-xs text-background-400 sm:flex-row">
          <p>© {new Date().getFullYear()} 韩漫漫画网 · 题材聚合内容平台</p>
          <p>本站为题材聚合与内容推荐站点，仅供信息参考</p>
        </div>
      </div>
    </footer>
  );
}